import React from "react";
import PropTypes from "prop-types";
import { fetchCall } from "../../service/service_base";
import NewsCard from "../CardPaper/NewsCard";
import { gaEventHit } from '../../service/service_base';
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import styles from "./grids-jss";

class GridCard extends React.Component {
  state = {
    notes: [],
    menuname: null
  };
  componentDidMount() {
    if (!this.props.isSearching) {
      this._load();
    } else {
      if (this.props.section) {
        this.setState(
          {
            contentElastic: []
          },
          () => {
            this.setState({
              notes: this.props.section.content
            });
          }
        );
      }
    }
  }

  _load = () => {
    fetchCall("POST", "/synthesis/getcontentpublish", {
      sectionId: this.props.section.sec_id,
      menuId: this.props.idMenuSelected
    })
      .then(response => {
        let sm = JSON.parse(localStorage.getItem("session_menu"))
      
        let menu = [];
        if (Array.isArray(sm)) {
          menu = sm.find(x => x.menu_id === this.props.idMenuSelected);
        }
        const menuname = menu;

        this.setState({ notes: response.data, menuname: menuname.menu_name });
      })
      .catch(err => console.log(err));
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.isSearching && nextProps.section) {
      this.setState({
        notes: nextProps.section.content
      });
    }
  }

  sendEvent = () => {
    if (this.state.menuname)
      gaEventHit(this.state.menuname, this.props.section.sec_name)
  }



  render() {
    const { isSearching, section, classes } = this.props;
    const notesImage = [], notesDescription = [], notesOnlyTitle = []
    this.state.notes.forEach((item) => {
      if (item.cont_imagePath !== '' && item.cont_key !== '') {
        item.cont_imagePath = item.cont_key;
        notesImage.push(item);
      } else if (item.cont_imagePath === '' && (item.cont_description !== '<p></p>' && item.cont_description.trim() !== '')) {
        notesDescription.push(item);
      } else {
        notesOnlyTitle.push(item);
      }
    }
    )

    return (
      <Grid container spacing={24}>
        {notesImage.length > 0 && <Grid item xs={12}>
          <Grid container spacing={24}>
            {this.state.notes.map((item, key) => {
              if (item.cont_imagePath !== "") {
                if (item.cont_key)
                  item.cont_imagePath = item.cont_key;
                return (
                  <Grid item lg={12} md={12} sm={12} xs={12} key={key}>
                    <NewsCard
                      horizontal
                      kicker={item.cont_program}
                      title={item.cont_name}
                      description={item.cont_description}
                      notes={item.cont_notas}
                      image={isSearching ? item.cont_imagePath : item.cont_key}
                      attachment={isSearching ? item.cont_attachment : item.cont_attachmentKey}
                      publish_date={item.publish_date}
                      colorTitle={section.sec_color}
                      sendEvent={this.sendEvent}
                      busqueda={isSearching}
                    />
                  </Grid>
                );
              }
            })}
          </Grid>
        </Grid>}
        {notesDescription.length > 0 && <Grid item xs={12}>
          <Grid container spacing={24}>
            {notesDescription.map((item, key) => {
              return (
                <Grid item lg={12} md={12} sm={12} xs={12} key={key}>
                  <NewsCard
                    kicker={item.cont_program}
                    title={item.cont_name}
                    description={item.cont_description}
                    notes={item.cont_notas}
                    attachment={isSearching ? item.cont_attachment : item.cont_attachmentKey}
                    publish_date={item.publish_date}
                    colorTitle={section.sec_color}
                    sendEvent={this.sendEvent}
                    busqueda={isSearching}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>}
        {notesOnlyTitle && <div className={classes.gridCardsTitle}>
          {notesOnlyTitle.map((item, key) => {
            const lastItem = key === notesOnlyTitle.length - 1;
            return (
              <div className={classes.gridCardItem}>
                <NewsCard
                  kicker={item.cont_program}
                  title={item.cont_name}
                  description={item.cont_description}
                  notes={item.cont_notas}
                  attachment={isSearching ? item.cont_attachment : item.cont_attachmentKey}
                  publish_date={item.publish_date}
                  colorTitle={section.sec_color}
                  sendEvent={this.sendEvent}
                  noDivider={lastItem}
                  busqueda={isSearching}
                />
              </div>
            );
          })}
        </div>}
      </Grid>
    );
  }
}

GridCard.propTypes = {
  classes: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
  idMenuSelected: PropTypes.any,
  isSearching: PropTypes.bool,
  noImage: PropTypes.string,
  noKicker: PropTypes.string,
  isWhiteBackground: PropTypes.bool,
};

export default withStyles(styles)(GridCard);
